import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=6bfcd3c5&scoped=true&"
import script from "./addressList.vue?vue&type=script&lang=ts&"
export * from "./addressList.vue?vue&type=script&lang=ts&"
import style0 from "./addressList.vue?vue&type=style&index=0&id=6bfcd3c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcd3c5",
  null
  
)

export default component.exports